var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',{staticClass:"back-btn cursor-pointer"},[_c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","to":{ name: 'LoginView' }}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-arrow-left")])],1)],1)]}}])},[_c('span',[_vm._v("Back to Login")])])}
var staticRenderFns = []

export { render, staticRenderFns }